import React, { useContext } from 'react'
import { array, func, bool } from 'prop-types'
import styled from 'styled-components'

import * as spacing from 'styles/spacing'
import { media } from 'styles/media'
import { cover } from 'styles/global'

import CheckoutContext from 'contexts/Checkout'
import NativeAuthContext from 'components/NativeAuth'

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: ${spacing.medium};

  ${media.large`
    grid-gap: ${spacing.large};
  `};
`

const Item = styled.div`
  position: relative;
  cursor: pointer;
`

const Color = styled.div`
  position: relative;
  padding-bottom: 100%;
`

const Figure = styled.img`
  ${cover('absolute')};
  object-fit: cover;
`

const FlavourList = ({ flavours, onClick, isDark }) => {
  const { products } = useContext(CheckoutContext)
  const { province } = useContext(NativeAuthContext)

  return (
    <Container>
      {flavours.map((flavour, i) => {
        const fetchedProduct = products.find(p => flavour.id?.includes(p.shopifyGid))
        if (fetchedProduct && !fetchedProduct?.availableProvinces.includes(province)) return null

        return (
          <Item key={i} data-tip={flavour.prettyName}>
            <Color
              isDark={isDark}
              onClick={() => {
                onClick(i)
              }}
            >
              <Figure src={`${process.env.BASE_PATH}/images/trial/flavours/${flavour.name}.png`} />
            </Color>
          </Item>
        )
      })}
    </Container>
  )
}

FlavourList.propTypes = {
  flavours: array.isRequired,
  onClick: func.isRequired,
  isDark: bool
}

export default FlavourList
